/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddPrintersRequest,
  UpdatePrinterRequest,
} from '../models/index';
import {
    AddPrintersRequestFromJSON,
    AddPrintersRequestToJSON,
    UpdatePrinterRequestFromJSON,
    UpdatePrinterRequestToJSON,
} from '../models/index';

export interface AddPrintersOperationRequest {
    addPrintersRequest: AddPrintersRequest;
}

export interface UpdatePrinterOperationRequest {
    id: string;
    updatePrinterRequest: UpdatePrinterRequest;
}

/**
 * 
 */
export class PrintersApi extends runtime.BaseAPI {

    /**
     */
    async addPrintersRaw(requestParameters: AddPrintersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['addPrintersRequest'] == null) {
            throw new runtime.RequiredError(
                'addPrintersRequest',
                'Required parameter "addPrintersRequest" was null or undefined when calling addPrinters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/printers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddPrintersRequestToJSON(requestParameters['addPrintersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addPrinters(requestParameters: AddPrintersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addPrintersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updatePrinterRaw(requestParameters: UpdatePrinterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePrinter().'
            );
        }

        if (requestParameters['updatePrinterRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePrinterRequest',
                'Required parameter "updatePrinterRequest" was null or undefined when calling updatePrinter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/printers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePrinterRequestToJSON(requestParameters['updatePrinterRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePrinter(requestParameters: UpdatePrinterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePrinterRaw(requestParameters, initOverrides);
    }

}
